import { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import MarketingBanner from './components/MarketingBanner';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ClassesSection from './components/ClassesSection';
import TeachersSection from './components/TeachersSection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import MonthlyWorksSection from './components/MonthlyWorksSection';
import Portal from '../../components/common/Portal';
import modalImg01 from '../../assets/popup20260701.jpg';
import { X } from "lucide-react";

const HomePage = () => {
  const POPUP_END_DATE = new Date("2026-07-15T23:59:59");
  const STORAGE_KEY = "live-class-popup-hide-until";

  const [showBanner, setShowBanner] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const now = new Date();
    if (now > POPUP_END_DATE) return;
    const hideUntil = localStorage.getItem(STORAGE_KEY);
    if (!hideUntil || new Date(hideUntil) <= now) {
      setShowModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleHideToday = () => {
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    localStorage.setItem(STORAGE_KEY, tomorrow.toISOString());
    setShowModal(false);
  };

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const target = searchParams.get("scroll");

    if (!target) return;

    const timer = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-white">
      {showBanner && <MarketingBanner onClose={() => setShowBanner(false)} />}
      <HeroSection />
      <FeaturesSection />
      <ClassesSection />
      <section id="monthlywork">
        <MonthlyWorksSection />
      </section>
      <TeachersSection />
      <NewsletterSection />
      <Footer />
      {showModal && (
        <Portal>
          <div className="absolute top-4 left-4 z-[9999] p-4">
            <div className="w-full max-w-md overflow-hidden border-2 border-black rounded-lg bg-white shadow-2xl">
              <a
                href="http://pf.kakao.com/_xjDIdX"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={modalImg01}
                  alt="popup"
                  className="w-full h-auto object-contain"
                />
              </a>
              <div className="flex items-center justify-between border-t bg-white px-4 py-3">
                <button
                  type="button"
                  onClick={handleHideToday}
                  className="text-sm text-slate-600 hover:text-slate-900"
                >
                  오늘 하루 안보기
                </button>
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="rounded-md p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-900"
                >
                  <X size={20} />
                </button>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default HomePage;
